import axios from 'axios';

const DEFAULT_CONFIG = {
    baseURL: process.env.REACT_APP_BASE_API_URL,
    googleBaseURL: process.env.REACT_APP_GOOGLE_API_URL
};

export default class BaseApi{
    constructor(config = DEFAULT_CONFIG){
        this.config = config;
        this.httpClient = axios.create({
            baseURL: this.config.baseURL,
            headers: {
                "Content-type" : "application/json; charset=UTF-8",
            }
        });

        this.httpClientGoogle = axios.create({
            baseURL: this.config.googleBaseURL,
            headers: {
                "Content-type" : "application/json; charset=UTF-8",
            }
        });
    }

    getHeaders(){
        const token = localStorage.getItem('token');

        if(token){
            const Authorization = `Bearer ${token}`;
            return { Authorization, ...this.config.headers };
        }
        else{
            return this.config.headers;
        }
    }

    callWithHeaders(options){
        return this.httpClient({
            ...options,
            headers:{
                ...this.getHeaders(),
            }
        });
    }

    callWithHeadersGoogle(options){
        return this.httpClientGoogle({
            ...options
        });
    }

    async get(url, data, requestConfig = {}){
        const response = await this.callWithHeaders({
            method : "GET",
            url : url,
            ...requestConfig,
        });

        return response;
    }

    async getGoogleUserInfo(url){
        const response = await this.callWithHeadersGoogle({
            method : "GET",
            url : url,
        });

        return response;
    }

    async post(url, data){
        const response = await this.callWithHeaders({ method:"POST", url, data});
        return response;
    }

    async put(url, data){
        const response = await this.callWithHeaders({ method:"PUT", url, data});
        return response;
    }

    async delete(url, data){
        const response = await this.callWithHeaders({ method:"DELETE", url, data});
        return response;
    }
}
